<template>
    <div class="px-3 pb-3">
        <v-btn block color="black" @click="userManager.logout()">Logout</v-btn>
    </div>
</template>

<script>
    export default {
        name: "NavigationSideFooter",
        methods: {
        },
    }
</script>

<style scoped>

</style>